/* eslint-disable no-useless-escape */
/**
 * 백엔드, 프론트엔드 공용 함수.
 * "es6 문법 사용 금지"(백엔드에 bable 사용 X)
 * 코드 변경시 양쪽 모두 업데이트 해야함. (양쪽에서 공동으로 사용하는 함수의 경우만)
 */

const accents = require("remove-accents");
const XRegExp = require("xregexp");

/**
 * 프론트엔드에서 사용하지 않는 하단의 검증코드는 지우자.
 */

const REGEX_NUMBER = /^[0-9]{1,}$/;
const REGEX_USERNAME = /^(?=.*[a-z0-9])[a-z0-9_-]*$/;
const REGEX_USERNAME_REPLACE = /[^a-z0-9_-]/g;
const REGEX_EMAIL =
  /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/;
const REGEX_BRAND_REPLACE = /[^A-Z0-9 ]/g;
/** 하단은 과거의 방식, 8자이상, 숫자+소문자+특수문자 */
// const REGEX_PASSWORD = /^(?=.*[0-9])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,}$/;
/** 현재 방식, 공백 제외한 8자이상 */
const REGEX_PASSWORD = /^\S{8,}$/;
const REGEX_OUTFIT_HASH = /^[a-zA-Z0-9]{1,}$/;
const REGEX_USER_HASH = /^[a-zA-Z0-9]{1,}$/;

const FIND_ENTIRE_HYPHEN_RE = XRegExp("[\\-\\–\\—]", "g");
const FIND_ESC_EXCEPT_HYPHEN_RE = XRegExp("[^\\-\\p{Ll}\\p{Lo}\\p{N}]", "gu");
const isNull = value => value == null; /** "===" 아니고 "==" 이다. */

const isValidDate = value => {
  /**
   * 자리수가 맞지않을때
   */
  if (isNaN(value) || value.length !== 8) {
    return false;
  }

  const year = Number(value.substring(0, 4));
  const month = Number(value.substring(4, 6));
  const day = Number(value.substring(6, 8));

  if (month < 1 || month > 12) {
    return false;
  }

  const maxDaysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  let maxDay = maxDaysInMonth[month - 1];

  /**
   * 윤년 체크
   */
  if (
    month === 2 &&
    ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0)
  ) {
    maxDay = 29;
  }

  if (day <= 0 || day > maxDay) {
    return false;
  }

  return true;
};

const regexFn = {
  isValid: {
    email: value => {
      if (isNull(value)) return false;
      return REGEX_EMAIL.test(value);
    },
    username: value => {
      if (isNull(value)) return false;
      return REGEX_USERNAME.test(value);
    },
    birthday: value => {
      if (isNull(value)) return false;
      else if (!REGEX_NUMBER.test(value)) return false;
      return isValidDate(value);
    },
    password: value => {
      if (isNull(value)) return false;
      return REGEX_PASSWORD.test(value);
    },
    outfitHash: value => {
      if (isNull(value)) return false;
      return REGEX_OUTFIT_HASH.test(value);
    },
    userHash: value => {
      if (isNull(value)) return false;
      return REGEX_USER_HASH.test(value);
    }
  },
  getFilteredValue: {
    username: text =>
      accents.remove(text).toLowerCase().replace(REGEX_USERNAME_REPLACE, ""),
    brand: text =>
      accents
        .remove(text)
        .toUpperCase()
        .replace(REGEX_BRAND_REPLACE, "")
        .replace(/ {2,}/g, " ")
        .trim(),
    tag: text => {
      const lowerCaseText = text.toLowerCase();
      const hyphenReplacedText = XRegExp.replace(
        lowerCaseText,
        FIND_ENTIRE_HYPHEN_RE,
        "-"
      );
      const textWithoutEsc = XRegExp.replace(
        hyphenReplacedText,
        FIND_ESC_EXCEPT_HYPHEN_RE,
        ""
      );
      return textWithoutEsc;
    },
    birthday: text => text.replace(/[^0-9]/g, "")
  }
};

module.exports.checker = regexFn;
